<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Tabs :value="tabs_name" type="card">
          <TabPane :label="tabs_label" name="name1">
            <v-table
              :title="this.personal_drive_set_record_title"
              :title_info="this.personal_drive_set_record_info"
              :table_columns="this.personal_drive_set_record_table_columns"
              :table_data="this.personal_drive_set_record_table_data"
              :table_ref="this.personal_drive_set_record_ref"
              :max_height="700"
              :init_table="this.personal_drive_set_record_init_table_func"
              :table_name_array="this.personal_drive_set_name_array"
              :show_top="false"
              :table_page_size="50"
            ></v-table>
            <Modal
              v-model="select_personal_drive_set_modal"
              :title="this.get_modal_title()"
              @on-ok="select_personal_drive_set_ok"
              @on-cancel="select_personal_drive_set_cancel"
            >
              <p slot="header" class="demo-drawer-hearde">
                <Icon type="information-circled"></Icon>
                <span>{{ this.get_modal_title() }}</span>
              </p>
              <Row type="flex" justify="start">
                <Form label-position="left" :label-width="120" :label-colon="true">
                  <FormItem label="调整余额">
                    <i-input
                      v-model="select_personal_drive_set_money"
                      :number="true"
                      placeholder="请输入..."
                    >
                      <span slot="append">USDT</span>
                    </i-input>
                  </FormItem>
                  <FormItem label="修改下单标的">
                    <Dropdown
                      @on-click="personal_drive_set_click_set_symbol"
                      trigger="click"
                      placement="bottom"
                    >
                      <a href="javascript:void(0)">
                        {{personal_drive_set_dropdown_set_symbol}}
                        <Icon type="md-arrow-dropdown" />
                      </a>
                      <Dropdown-menu slot="list">
                        <Dropdown-item name="0">BTCUSDT</Dropdown-item>
                        <Dropdown-item name="1">ETHUSDT</Dropdown-item>
                        <Dropdown-item name="2">BTCUSD_PERP</Dropdown-item>
                      </Dropdown-menu>
                    </Dropdown>
                  </FormItem>
                  <FormItem label="修改下单类型">
                    <Dropdown
                      @on-click="personal_drive_set_click_order_style"
                      trigger="click"
                      placement="bottom"
                    >
                      <a href="javascript:void(0)">
                        {{personal_drive_set_dropdown_order_style}}
                        <Icon type="md-arrow-dropdown" />
                      </a>
                      <Dropdown-menu slot="list">
                        <Dropdown-item name="0">脉冲形式</Dropdown-item>
                        <Dropdown-item name="1">限价追单</Dropdown-item>
                        <Dropdown-item name="2">市价</Dropdown-item>
                      </Dropdown-menu>
                    </Dropdown>
                  </FormItem>
                  <FormItem label="修改可用仓位">
                    <i-input
                      v-model="select_personal_drive_set_position_index"
                      :number="true"
                      placeholder="请输入..."
                    >
                      <span slot="append">%</span>
                    </i-input>
                  </FormItem>
                  <FormItem label="修改止盈百分比">
                    <i-input
                      v-model="select_personal_drive_set_gain_percent"
                      :number="true"
                      placeholder="请输入..."
                    >
                      <span slot="append">%</span>
                    </i-input>
                  </FormItem>
                  <FormItem label="修改止损百分比">
                    <i-input
                      v-model="select_personal_drive_set_loss_percent"
                      :number="true"
                      placeholder="请输入..."
                    >
                      <span slot="append">%</span>
                    </i-input>
                  </FormItem>
                </Form>
              </Row>
            </Modal>
          </TabPane>
          <TabPane :label="tabs_labe2" name="name2">
            <Split v-model="split_percent">
              <div slot="left">
                <v-table
                  :title="this.personal_drive_show_record_title"
                  :title_info="this.personal_drive_show_record_info"
                  :table_columns="this.personal_drive_show_record_table_columns"
                  :table_data="this.personal_drive_show_record_table_data"
                  :table_ref="this.personal_drive_show_record_ref"
                  :max_height="700"
                  :init_table="this.personal_drive_show_record_init_table_func"
                  :table_name_array="this.personal_drive_show_name_array"
                  :show_top="false"
                  :show_page="true"
                  :table_page_size="50"
                ></v-table>
              </div>

              <div slot="right">
                <Row>
                  <Col offset="1" span="23">
                    <Row style="height:60px;"></Row>
                    <Row>
                      <Col span="11">
                        <Button type="success" size="large" long @click="execute_order(0)">开仓--做多</Button>
                      </Col>

                      <Col offset="2" span="11">
                        <Button type="error" size="large" long @click="execute_order(1)">开仓--做空</Button>
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Button type="info" size="large" long @click="execute_order(2)">普通平仓</Button>
                    </Row>
                    <br />
                    <Row>
                      <Button type="warning" size="large" long @click="execute_order(3)">止损</Button>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Split>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import table_view from "../components/TableView.vue";

export default {
  name: "tools_personDriver",
  components: {
    "v-table": table_view,
  },
  data() {
    return {
      timer: null,
      table_title: "手动介入，执行交易",
      tabs_name: "name2",
      tabs_label: "设置",
      tabs_labe2: "实盘",
      split_percent: 0.85,
      personal_drive_set_dropdown_order_style: null,
      personal_drive_set_dropdown_set_symbol:null,
      select_personal_drive_set_modal: false,
      select_personal_drive_set_index: null,
      select_personal_drive_set_money: 0,
      select_personal_drive_set_position_index: 0,
      select_personal_drive_set_gain_percent: 0,
      select_personal_drive_set_loss_percent: 0,
      personal_drive_set_record_title: "",
      personal_drive_set_record_info: [],
      personal_drive_set_record_table_columns: [],
      personal_drive_set_record_table_data: [],
      personal_drive_set_record_ref: "personal_drive_set_record_ref",
      personal_drive_set_name_array: [
        "账户编号",
        "账户邮箱",
        "账户说明",
        "当前可用余额",
        "下单标的",
        "单次下单可用仓位",
        "止盈百分比",
        "止损百分比",
        "下单策略",
        "启用状态",
      ],

      personal_drive_show_record_title: "",
      personal_drive_show_record_info: [],
      personal_drive_show_record_table_columns: [],
      personal_drive_show_record_table_data: [],
      personal_drive_show_record_ref: "personal_drive_show_record_ref",
      personal_drive_show_name_array: [
        "账户编号",
        "方向",
        "数量",
        "下单标的",
        "成本价",
        "现价",
        "止盈价",
        "止损价",
        "未实现盈亏",
        "执行进度",
      ],
      personal_drive_show_slider: [],
    };
  },
  watch: {
    select_personal_drive_set_modal(old_value) {
      if (this.select_personal_drive_set_modal == true) {
        //打开了modal
        // 判断当前所选行的下单策略
        this.select_personal_drive_set_money = 0;
        for (var i = 0;i < this.personal_drive_set_record_table_data.length;i++) {
          if (this.personal_drive_set_record_table_data[i][0] == this.select_personal_drive_set_index) {
            //console.log(this.personal_drive_set_record_table_data[i])
            this.personal_drive_set_dropdown_set_symbol = this.personal_drive_set_record_table_data[i][4];
            this.personal_drive_set_dropdown_order_style = this.personal_drive_set_record_table_data[i][8];
            this.select_personal_drive_set_position_index = this.personal_drive_set_record_table_data[i][5];
            this.select_personal_drive_set_gain_percent = this.personal_drive_set_record_table_data[i][6];
            this.select_personal_drive_set_loss_percent = this.personal_drive_set_record_table_data[i][7];
            break;
          }
        }
      }
    },
  },
  methods: {
    setTimer: function (interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.load_tables_data_set();
        }, interval);
      }
    },
    personal_drive_set_click_set_symbol: async function (key) {
      // 判断当前所选行的下单标的
      let key_index = { 0: "BTCUSDT", 1: "ETHUSDT", 2: "BTCUSD_PERP"};
      for (var i = 0;i < this.personal_drive_set_record_table_data.length;i++) {
        if (this.personal_drive_set_record_table_data[i][0] == this.select_personal_drive_set_index) {
          this.personal_drive_set_record_table_data[i][6] = key_index[key];
          this.personal_drive_set_dropdown_set_symbol = key_index[key];
          setTimeout(async () => {
            const formData = new FormData();
            formData.append("account_id", this.select_personal_drive_set_index);
            formData.append("data", JSON.stringify({ set_symbol: key }));
            formData.append("mode", "change_set_symbol");
            await this.$axios({
              url: this.$store.state.urlPort + "/person_driver",
              method: "post",
              data: formData,
            });
          }, 100);
          break;
        }
      }
    },
    personal_drive_set_click_order_style: async function (key) {
      // 判断当前所选行的下单策略
      let key_index = { 0: "脉冲形式", 1: "限价追单形式", 2: "直接市价形式" };
      for (
        var i = 0;
        i < this.personal_drive_set_record_table_data.length;
        i++
      ) {
        if (
          this.personal_drive_set_record_table_data[i][0] ==
          this.select_personal_drive_set_index
        ) {
          this.personal_drive_set_record_table_data[i][5] = key_index[key];
          this.personal_drive_set_dropdown_order_style = key_index[key];
          setTimeout(async () => {
            const formData = new FormData();
            formData.append("account_id", this.select_personal_drive_set_index);
            formData.append("data", JSON.stringify({ order_type: key }));
            formData.append("mode", "change_order_type");
            await this.$axios({
              url: this.$store.state.urlPort + "/person_driver",
              method: "post",
              data: formData,
            });
          }, 100);
          break;
        }
      }
    },
    personal_drive_set_click_update_balance: async function () {
      // 判断当前所选行的下单策略
      for (var i = 0; i < this.personal_drive_set_record_table_data.length; i++) {
        if (
          this.personal_drive_set_record_table_data[i][0] ==
          this.select_personal_drive_set_index
        ) {
          setTimeout(async () => {
            const formData = new FormData();
            formData.append("account_id", this.select_personal_drive_set_index);
            formData.append("data", JSON.stringify({ }));
            formData.append("mode", "update_balance");
            await this.$axios({
              url: this.$store.state.urlPort + "/person_driver",
              method: "post",
              data: formData,
            });
          }, 100);
          setTimeout(() => {
            this.load_tables_data_set();
          }, 300);
          break;
        }
      }
    },
    execute_order: async function (order_num) {
      let data = [];
      for (
        var i = 0;
        i < this.personal_drive_show_record_table_data.length;
        i++
      ) {
        data.push({
          account_id: this.personal_drive_show_record_table_data[i][0],
          order_num: order_num,
        });
      }
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      formData.append("mode", "execute_order");
      await this.$axios({
        url: this.$store.state.urlPort + "/person_driver",
        method: "post",
        data: formData,
      });
    },
    get_modal_title: function () {
      return this.select_personal_drive_set_index + "号账户";
    },
    select_personal_drive_set_ok: async function () {
      let formData = new FormData();
      formData = new FormData();
      formData.append(
        "data",
        JSON.stringify({ 
          position_index: this.select_personal_drive_set_position_index / 100,
          change_balance: this.select_personal_drive_set_money,
          stop_gain_percent: this.select_personal_drive_set_gain_percent / 100,
          stop_loss_percent: this.select_personal_drive_set_loss_percent / 100
        })
      );
      formData.append("account_id", this.select_personal_drive_set_index);
      formData.append("mode", "fun_test");
      await this.$axios({
        url: this.$store.state.urlPort + "/person_driver",
        method: "post",
        data: formData,
      });
      this.select_personal_drive_set_money = 0;

      setTimeout(() => {
        this.load_tables_data_set();
      }, 100);
    },
    select_personal_drive_set_cancel: function () {
      this.select_personal_drive_set_money = 0;
    },
    load_tables_data_show: async function () {
      let apply_id = [];
      for (
        var i = 0;
        i < this.personal_drive_set_record_table_data.length;
        i++
      ) {
        if (this.personal_drive_set_record_table_data[i][6] != 0) {
          apply_id.push(this.personal_drive_set_record_table_data[i][0]);
        }
      }
      let personal_drive_show_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/person_driver",
        {
          params: {
            mode: "get_show_table_msg",
            data: JSON.stringify({ apply_id: apply_id }),
          },
        }
      );
      this.set_personal_drive_show_record_data(personal_drive_show_record_data);
    },
    load_tables_data_set: async function () {
      let personal_drive_set_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/person_driver",
        {
          params: {
            mode: "get_set_table_msg",
          },
        }
      );
      this.set_personal_drive_set_record_data(personal_drive_set_record_data);
      this.load_tables_data_show();
    },
    personal_drive_set_record_init_table_func: function () {
      const name_array = this.personal_drive_set_name_array;
      this.personal_drive_set_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.personal_drive_set_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center",
        });
      }

      // this.personal_drive_set_record_table_columns[0]["minWidth"] = 155;
      this.personal_drive_set_record_table_columns[1]["minWidth"] = 80;
      this.personal_drive_set_record_table_columns[2]["minWidth"] = 80;

      // this.personal_drive_set_record_table_columns[1]["tooltip"] = true;
      this.personal_drive_set_record_table_columns[2]["tooltip"] = true;

      this.personal_drive_set_record_table_columns[3]["minWidth"] = 80;
      this.personal_drive_set_record_table_columns[3]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["当前可用余额"];
        var set_symbol = params["row"]["下单标的"];
        if (value != null || value != "") {
          if (set_symbol == "BTCUSD_PERP") {
            value = parseFloat(value).toFixed(5);
          }
          else {
            value = parseFloat(value).toFixed(2);
          }
        } else {
          value = 0
        }
        
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                "color": "#0066FF",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.personal_drive_set_click_update_balance();
                }
              }
            },
            "刷新"
          )
        ]);
      };

      this.personal_drive_set_record_table_columns[4]["tooltip"] = true;
      this.personal_drive_set_record_table_columns[4]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["下单标的"];
        
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value
          ),
        ]);
      };
      this.personal_drive_set_record_table_columns[5]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["单次下单可用仓位"];
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value + " %"
          ),
        ]);
      };
      this.personal_drive_set_record_table_columns[6]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["止盈百分比"];
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value + " %"
          ),
        ]);
      };
      this.personal_drive_set_record_table_columns[7]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["止损百分比"];
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value + " %"
          ),
        ]);
      };
      this.personal_drive_set_record_table_columns[8]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["下单策略"];
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                loading: false,
              },
              style: {
                border: "hidden",
                "font-size": "12px",
                background: "transparent",
              },
              on: {
                click: () => {
                  this.select_personal_drive_set_index =
                    params["row"]["账户编号"];
                  this.select_personal_drive_set_modal = true;
                },
              },
            },
            value
          ),
        ]);
      };
      this.personal_drive_set_record_table_columns[9]["render"] = (
        h,
        params
      ) => {
        return h("div", [
          this.$createElement("i-switch", {
            props: {
              size: "large",
              "true-color": "#13ce66",
              loading: false,
              value:
                this.personal_drive_set_record_table_data[params["index"]][9] ==
                1
                  ? true
                  : false,
            },
            style: {
              marginRight: "5px",
            },
            scopedSlots: {
              open: () => h("span", "开启"),
              close: () => h("span", "关闭"),
            },
            on: {
              "on-change": async (status) => {
                this.$set(
                  this.personal_drive_set_record_table_data[params["index"]],
                  9,
                  status
                );
                const formData = new FormData();
                formData.append(
                  "data",
                  JSON.stringify({ value: status == false ? 0 : 1 })
                );
                formData.append("account_id", params["row"]["账户编号"]);
                formData.append("mode", "change_flag_start_status");
                let data = await this.$axios({
                  url: this.$store.state.urlPort + "/person_driver",
                  method: "post",
                  data: formData,
                });
              },
            },
            ref: "set_up_report_switch",
            // 如果你在渲染函数中给多个元素都应用了相同的 ref 名，
            // 那么 `$refs.myRef` 会变成一个数组。
            refInFor: true,
          }),
        ]);
      };
    },
    set_personal_drive_set_record_data: function (data) {
      this.personal_drive_set_record_title = data["name"];
      this.personal_drive_set_record_table_data = [];
      for (var i = 0; i < data["data"].length; i++) {
        this.personal_drive_set_record_table_data.push(data["data"][i]);
      }
    },
    personal_drive_show_record_init_table_func: function () {
      const name_array = this.personal_drive_show_name_array;
      this.personal_drive_show_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.personal_drive_show_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center",
        });
      }
      //this.personal_drive_show_record_table_columns[5];
    },
    set_personal_drive_show_record_data: function (data) {
      this.personal_drive_show_record_title = data["name"];
      this.personal_drive_show_record_table_data = [];
      for (var i = 0; i < data["data"].length; i++) {
        this.personal_drive_show_record_table_data.push(data["data"][i]);
      }
    },
    personal_drive_show_record_init_table_func: function () {
      const name_array = this.personal_drive_show_name_array;
      this.personal_drive_show_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.personal_drive_show_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center",
        });
      }
      // this.personal_drive_show_record_table_columns[1]["minWidth"] = 80;
      // this.personal_drive_show_record_table_columns[2]["minWidth"] = 80;
      // this.personal_drive_show_record_table_columns[2]["tooltip"] = true;

      this.personal_drive_show_record_table_columns[1]["render"] = (
        h,
        params
      ) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        var color;
        if (buy_sell.indexOf("buy") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        if (buy_sell == "空仓") {
          color = "#000000";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.personal_drive_show_record_table_columns[2]["render"] = (
        h,
        params
      ) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        var color;
        if (buy_sell.indexOf("buy") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        if (buy_sell == "空仓") {
          color = "#000000";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.personal_drive_show_record_table_columns[4]["render"] = (
        h,
        params
      ) => {
        var value =
          Math.round(params["row"][params["column"]["key"]] * 100) / 100;
        return h("div", [
          h(
            "span",
            {
              style: {},
            },
            value
          ),
        ]);
      };
      this.personal_drive_show_record_table_columns[8]["minWidth"] = 80;
      this.personal_drive_show_record_table_columns[9]["minWidth"] = 80;
      this.personal_drive_show_record_table_columns[9]["render"] = (
        h,
        params
      ) => {
        var value = params["row"]["执行进度"];
        if (value[1] == 0) {
          var percent = 0;
        } else {
          var percent = Math.round((100 * value[0]) / value[1]);
        }

        var index = params["index"];
        return h("div", [
          this.$createElement("Progress", {
            props: {
              percent: percent,
              status: "active",
            },
            style: {},
            ref: "personal_drive_show_progress",
          }),
        ]);
      };
    },
  },
  mounted() {
    this.account_id = this.$route.path.split("=")[1];
    this.load_tables_data_set();
  },
  created: function () {
    clearInterval(this.timer);
    this.timer = null;
    // 刷新频率
    this.setTimer(3 * 1000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.demo-drawer-hearde {
  width: 100%;

  text-align: center;
  background: #fff;
}
</style>